import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
  InputSignal,
  OnChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViaSupportService } from '../../../services/support/via-support/via-support.service';
import { ViaName } from '@web/dtos';

@Component({
  selector: 'aw-via-list',
  imports: [CommonModule],
  templateUrl: './via-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ViaListComponent implements OnChanges {
  private viaService: ViaSupportService = inject(ViaSupportService);
  public readonly via: InputSignal<ViaName[]> = input.required();
  public viaAriaLabel: string = '';

  ngOnChanges(): void {
    this.viaAriaLabel = this.viaService.buildViaString(this.via());
  }
}
